import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from '../../components/Button';
import { Checkbox, Grid, Icon, Input, Table } from 'semantic-ui-react';
import { maskCnpj } from '../../services/masks';
import { BrokerState } from '../../types/BrokerState';
import { EstateData } from './components/EstateData';
import { BankAccountData } from './components/BankAccountData';
import { EstateFormProps } from './EstateForm';
import { BondInsuranceData } from './components/BondInsuranceData';
import { FireInsuranceData } from './components/FireInsuranceData';
import Loader from '../../components/Loader';
import { CapitalizationInsuranceData } from './components/CapitalizationInsuranceData';
import { specialCharRemove } from '../../utils/string.util';
import SectionLabel from '../../components/SectionLabel';
import { StepCard } from '../estates-edit-form/styles';
import { InsurersCodeEnum } from '../../enums/insurers-code.enum';
import { TypeOfFeesType } from '../estates-edit-form/types';
import IconButton from '../../components/IconButton';
import { PromotionalSection } from './components/PromotionalSection';

const EstateContainer = styled.div`
  height: 100%;
`;

const handleFormInputChange = (data: any, formProps: EstateFormProps) => {
  const { setFieldValue } = formProps;
  const { field } = data;
  let { value } = data;

  if (field.name === 'estate[cnpj]') {
    value = maskCnpj(value);
  }

  if (
    [
      'name',
      'company_name',
      'estate_district',
      'estate_city',
      'estate_complement'
    ].includes(field.name)
  ) {
    value = specialCharRemove(value);
  }

  if (field.name === 'estate_number') {
    value = value.replace(/\D/g, '');
  }

  setFieldValue(field.name, value);
};

const ServiceSelector: React.FC<{ step: number; setStep: (s: number) => void }> = ({
  step,
  setStep
}) => {
  return (
    <Grid.Row>
      <Grid.Column width={4}>
        <StepCard
          active={step === 1}
          onClick={() => {
            setStep(1);
          }}
        >
          <span>
            <Icon name="shield" color={step === 1 ? undefined : 'grey'} /> Seguro Fiança
          </span>
        </StepCard>
      </Grid.Column>
      <Grid.Column width={5}>
        <StepCard
          active={step === 2}
          onClick={() => {
            setStep(2);
          }}
        >
          <span>
            <Icon name="fire" color={step === 2 ? undefined : 'grey'} /> Seguro Incêndio
          </span>
        </StepCard>
      </Grid.Column>
      <Grid.Column width={4}>
        <StepCard
          active={step === 3}
          onClick={() => {
            setStep(3);
          }}
        >
          <span>
            <Icon name="money bill alternate" color={step === 3 ? undefined : 'grey'} />{' '}
            Capitalização
          </span>
        </StepCard>
      </Grid.Column>
    </Grid.Row>
  );
};

const EstateFormContent = (props: EstateFormProps) => {
  const [step, setStep] = useState(1);
  const [disabledButtonFormm, setDisabledButtonForm] = useState<boolean>(false);
  const [commissions, setCommissions] = useState([
    {
      insurerCode: InsurersCodeEnum.Pottencial,
      insurerName: 'Pottencial Seguradora',
      type: 'residential',
      brokerFee: 30,
      estateFee: 15,
      brokerRepass: true,
      variableProlabore: 0,
      product: 'BOND_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.Pottencial,
      insurerName: 'Pottencial Seguradora',
      type: 'commercial',
      brokerFee: 30,
      estateFee: 15,
      brokerRepass: true,
      variableProlabore: 0,
      product: 'BOND_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.Fairfax,
      insurerName: 'Fairfax Brasil',
      type: 'residential',
      brokerFee: 30,
      estateFee: 18,
      brokerRepass: true,
      variableProlabore: 0,
      product: 'BOND_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.Fairfax,
      insurerName: 'Fairfax Brasil',
      type: 'commercial',
      brokerFee: 30,
      estateFee: 18,
      brokerRepass: true,
      variableProlabore: 0,
      product: 'BOND_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.Porto,
      insurerName: 'Porto Seguro Tradicional',
      type: 'residential',
      brokerFee: 30,
      estateFee: 15,
      brokerRepass: true,
      variableProlabore: 0,
      product: 'BOND_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.Porto,
      insurerName: 'Porto Seguro Tradicional',
      type: 'commercial',
      brokerFee: 30,
      estateFee: 15,
      brokerRepass: true,
      variableProlabore: 0,
      product: 'BOND_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.PortoEssencial,
      insurerName: 'Porto Seguro',
      type: 'residential',
      brokerFee: 30,
      estateFee: 10,
      brokerRepass: true,
      variableProlabore: 0,
      product: 'BOND_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.PortoEssencial,
      insurerName: 'Porto Seguro',
      type: 'commercial',
      brokerFee: 30,
      estateFee: 10,
      brokerRepass: true,
      variableProlabore: 0,
      product: 'BOND_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.Too,
      insurerName: 'Too Seguros',
      type: 'residential',
      brokerFee: 30,
      estateFee: 15,
      brokerRepass: true,
      variableProlabore: 0,
      product: 'BOND_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.Too,
      insurerName: 'Too Seguros',
      type: 'commercial',
      brokerFee: 30,
      estateFee: 15,
      brokerRepass: true,
      variableProlabore: 0,
      product: 'BOND_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.TokioMarine,
      insurerName: 'Tokio Marine',
      type: 'residential',
      brokerFee: 30,
      estateFee: 15,
      brokerRepass: true,
      variableProlabore: 0,
      product: 'BOND_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.TokioMarine,
      insurerName: 'Tokio Marine',
      type: 'commercial',
      brokerFee: 30,
      estateFee: 15,
      brokerRepass: true,
      variableProlabore: 0,
      product: 'BOND_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.TokioMarine,
      insurerName: 'Tokio Marine',
      type: 'residential',
      brokerFee: 30,
      estateFee: 40,
      brokerRepass: false,
      variableProlabore: 10,
      product: 'FIRE_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.TokioMarine,
      insurerName: 'Tokio Marine',
      type: 'commercial',
      brokerFee: 30,
      estateFee: 40,
      brokerRepass: false,
      variableProlabore: 10,
      product: 'FIRE_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.Zurich,
      insurerName: 'Zurich',
      type: 'residential',
      brokerFee: 30,
      estateFee: 40,
      brokerRepass: false,
      variableProlabore: 10,
      product: 'FIRE_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.Zurich,
      insurerName: 'Zurich',
      type: 'commercial',
      brokerFee: 30,
      estateFee: 40,
      brokerRepass: false,
      variableProlabore: 10,
      product: 'FIRE_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.alfa,
      insurerName: 'Alfa Seguros',
      type: 'residential',
      brokerFee: 30,
      estateFee: 40,
      brokerRepass: false,
      variableProlabore: 10,
      product: 'FIRE_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.alfa,
      insurerName: 'Alfa Seguros',
      type: 'commercial',
      brokerFee: 30,
      estateFee: 40,
      brokerRepass: false,
      variableProlabore: 10,
      product: 'FIRE_INSURANCE'
    },
    {
      insurerCode: InsurersCodeEnum.Porto,
      insurerName: 'Porto Seguro',
      type: '12',
      brokerFee: 3,
      estateFee: 0.5,
      brokerRepass: false,
      variableProlabore: 15,
      product: 'CAPITALIZATION'
    },
    {
      insurerCode: InsurersCodeEnum.Porto,
      insurerName: 'Porto Seguro',
      type: '15',
      brokerFee: 4,
      estateFee: 0.75,
      brokerRepass: false,
      variableProlabore: 15,
      product: 'CAPITALIZATION'
    },
    {
      insurerCode: InsurersCodeEnum.Porto,
      insurerName: 'Porto Seguro',
      type: '18',
      brokerFee: 5,
      estateFee: 1,
      brokerRepass: false,
      variableProlabore: 15,
      product: 'CAPITALIZATION'
    },
    {
      insurerCode: InsurersCodeEnum.Porto,
      insurerName: 'Porto Seguro',
      type: '24',
      brokerFee: 5,
      estateFee: 1.25,
      brokerRepass: false,
      variableProlabore: 15,
      product: 'CAPITALIZATION'
    },
    {
      insurerCode: InsurersCodeEnum.Porto,
      insurerName: 'Porto Seguro',
      type: '30',
      brokerFee: 5,
      estateFee: 1.5,
      brokerRepass: false,
      variableProlabore: 15,
      product: 'CAPITALIZATION'
    },
    {
      insurerCode: InsurersCodeEnum.Icatu,
      insurerName: 'Icatu Seguros',
      type: '12',
      brokerFee: 5,
      estateFee: 1,
      brokerRepass: false,
      variableProlabore: 15,
      product: 'CAPITALIZATION'
    },
    {
      insurerCode: InsurersCodeEnum.Icatu,
      insurerName: 'Icatu Seguros',
      type: '15',
      brokerFee: 6,
      estateFee: 0.75,
      brokerRepass: false,
      variableProlabore: 15,
      product: 'CAPITALIZATION'
    },
    {
      insurerCode: InsurersCodeEnum.Icatu,
      insurerName: 'Icatu Seguros',
      type: '18',
      brokerFee: 7,
      estateFee: 1,
      brokerRepass: false,
      variableProlabore: 15,
      product: 'CAPITALIZATION'
    },
    {
      insurerCode: InsurersCodeEnum.Icatu,
      insurerName: 'Icatu Seguros',
      type: '24',
      brokerFee: 7.5,
      estateFee: 1.25,
      brokerRepass: false,
      variableProlabore: 15,
      product: 'CAPITALIZATION'
    },
    {
      insurerCode: InsurersCodeEnum.Icatu,
      insurerName: 'Icatu Seguros',
      type: '30',
      brokerFee: 8,
      estateFee: 1.5,
      brokerRepass: false,
      variableProlabore: 15,
      product: 'CAPITALIZATION'
    }
  ]);
  const { availableBrokersAndEstates, setFieldValue, isLoading } = props;
  const selectedBroker: BrokerState =
    availableBrokersAndEstates.brokers.length === 1
      ? availableBrokersAndEstates.brokers[0].value
      : null;

  useEffect(() => {
    if (selectedBroker) {
      setFieldValue('broker', selectedBroker);
    }
  }, []);

  if (isLoading) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <EstateContainer>
      {isLoading && (
        <>
          <Loader />
        </>
      )}
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <Grid>
              <EstateData
                {...props}
                handleInputChange={handleFormInputChange}
                setDisabledButtonForm={setDisabledButtonForm}
              />
              <BankAccountData {...props} handleInputChange={handleFormInputChange} />
              <SectionLabel
                text="CONFIGURAR SERVIÇOS"
                ReactItem={() => (
                  <IconButton name="exclamation circle" style={{ fontSize: 18 }} />
                )}
              />

              <ServiceSelector step={step} setStep={(s: number) => setStep(s)} />
              {step === 1 ? (
                <BondInsuranceData {...props} handleInputChange={handleFormInputChange} />
              ) : step === 2 ? (
                <FireInsuranceData {...props} handleInputChange={handleFormInputChange} />
              ) : step === 3 ? (
                <CapitalizationInsuranceData
                  {...props}
                  handleInputChange={handleFormInputChange}
                />
              ) : (
                <></>
              )}
            </Grid>
          </Grid.Column>
          <Grid.Column width={16}>
            <SectionLabel
              text={`COMISSIONAMENTO ${
                step === 1
                  ? 'SEGURO FIANÇA'
                  : step === 2
                  ? 'SEGURO INCÊNDIO'
                  : 'CAPITALIZAÇÃO'
              }`}
            />
            <Table celled>
              <Table.Header fullWidth>
                <Table.Row>
                  <Table.HeaderCell>SEGURADORA</Table.HeaderCell>
                  <Table.HeaderCell>TIPO</Table.HeaderCell>
                  <Table.HeaderCell>COMISSÃO CORRETORA</Table.HeaderCell>
                  <Table.HeaderCell>COMISSÃO IMOBILIÁRIA</Table.HeaderCell>
                  <Table.HeaderCell>COMISSÃO FRANQUEADO</Table.HeaderCell>
                  <Table.HeaderCell>REPASSE VIA CORRETORA</Table.HeaderCell>
                </Table.Row>
                {commissions
                  ?.filter(
                    item =>
                      item.product ===
                      (step === 1
                        ? 'BOND_INSURANCE'
                        : step === 2
                        ? 'FIRE_INSURANCE'
                        : 'CAPITALIZATION')
                  )
                  ?.map((item, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>{item?.insurerName}</Table.Cell>
                      <Table.Cell>
                        {TypeOfFeesType[item?.type as keyof typeof TypeOfFeesType]}
                      </Table.Cell>
                      <Table.Cell>
                        <Input
                          disabled={
                            item.product !== 'BOND_INSURANCE' &&
                            item.product !== 'FIRE_INSURANCE'
                          }
                          value={item.brokerFee}
                          label="%"
                          labelPosition="right"
                          type="number"
                          onChange={(_, { value }) => {
                            setCommissions(prev =>
                              prev.map(comm =>
                                comm.insurerCode + comm.product ===
                                  item.insurerCode + item.product &&
                                comm.type === item.type
                                  ? { ...comm, brokerFee: Number(value) }
                                  : comm
                              )
                            );
                          }}
                        />
                      </Table.Cell>
                      <Table.Cell>
                        <Input
                          label="%"
                          labelPosition="right"
                          type="number"
                          disabled={item.product === 'CAPITALIZATION'}
                          value={item.estateFee}
                          onChange={(_, { value }) => {
                            const numValue = Number(value);
                            const updates = {
                              estateFee: numValue
                            };

                            if (item.product === 'FIRE_INSURANCE') {
                              // Calcula pró-labore baseado no valor da comissão
                              const prolaboreRanges = [
                                { min: 50, value: 2 },
                                { min: 40, value: 4 },
                                { min: 30, value: 7 },
                                { min: 20, value: 10 },
                                { min: 10, value: 15 },
                                { min: 0, value: 20 }
                              ];
                              const prolabore =
                                prolaboreRanges.find(range => numValue > range.min)
                                  ?.value || 20;
                              const updates2 = {
                                ...updates,
                                variableProlabore: prolabore
                              };

                              // Ajusta comissão da corretora para total de 70%
                              if (numValue <= 70) {
                                // setCommissions(prev =>
                                //   prev.map(comm =>
                                //     comm.insurerCode + comm.product === item.insurerCode + item.product && comm.type === item.type
                                //       ? { ...comm, ...updates2, brokerFee: 70 - numValue }
                                //       : comm
                                //   )
                                // );

                                setCommissions(prev =>
                                  prev.map(comm =>
                                    comm.insurerCode + comm.product ===
                                      item.insurerCode + item.product &&
                                    comm.type === item.type
                                      ? { ...comm, ...updates2 }
                                      : comm
                                  )
                                );
                              }
                            }

                            setCommissions(prev =>
                              prev.map(comm =>
                                comm.insurerCode + comm.product ===
                                  item.insurerCode + item.product &&
                                comm.type === item.type
                                  ? { ...comm, ...updates }
                                  : comm
                              )
                            );
                          }}
                        />
                      </Table.Cell>

                      <Table.Cell>
                        <Input
                          label="%"
                          labelPosition="right"
                          type="number"
                          disabled={item.product !== 'BOND_INSURANCE'}
                          value={item.variableProlabore}
                          onChange={(_, { value }) => {
                            setCommissions(prev =>
                              prev.map(comm =>
                                comm.insurerCode + comm.product ===
                                  item.insurerCode + item.product &&
                                comm.type === item.type
                                  ? { ...comm, variableProlabore: Number(value) }
                                  : comm
                              )
                            );
                          }}
                        />
                      </Table.Cell>

                      <Table.Cell>
                        <Checkbox
                          checked={item.brokerRepass}
                          toggle
                          disabled={item.product === 'CAPITALIZATION'}
                          onChange={() => {
                            setCommissions(prev =>
                              prev.map(comm =>
                                comm.insurerCode + comm.product ===
                                  item.insurerCode + item.product &&
                                comm.type === item.type
                                  ? { ...comm, brokerRepass: !comm.brokerRepass }
                                  : comm
                              )
                            );
                          }}
                        />
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Header>
            </Table>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="left" width={16}>
            <Button
              text="Cadastrar"
              color="green"
              size="large"
              type="submit"
              onClick={() => {
                props.onSubmit({
                  ...props.values,
                  commissions: commissions,
                  selectedPromotions: props.values.selectedPromotions || []
                });
              }}
              disabled={disabledButtonFormm}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </EstateContainer>
  );
};

export default EstateFormContent;
